module.exports = __webpack_public_path__ + "img/page-23.784f04f8.jpg";